import React from 'react'

function KundliMatching() {
  return (
    <section className="notifications-bg py-8 md:py-12 bg-white">
     <div className='container'>
        <div className='mb-6 md:mb-8'>
           <div className='flex flex-col gap-[15px]'>
            <h1 className='web-h3 text-gray-950'>Kundli Matching</h1>
            <p className='body-md text-gray-600'>Enter girl and boy details</p>
           </div> 
           <h2 className='web-h5 text-gray-950 mt-4'>Girl Details</h2>
        </div>
        
        <div className='grid grid-cols-2 gap-[15px]'>
          <div className="flex-col flex gap-[8px]">
            <label className="text-[15px] text-gray-950 semibold">
                Name
            </label>
            <input type="text" id="name" className="custom-input" placeholder="Enter name"/>
          </div>  

          <div className="flex-col flex gap-[8px]">
            <label className="text-[15px] text-gray-950 semibold">
            Date of Birth
            </label>
            <input type="time" id="name" className="custom-input" placeholder="Select Date of Birth"/>
          </div>  

          <div className="flex-col flex gap-[8px]">
            <label className="text-[15px] text-gray-950 semibold">
            Time of Birth
            </label>
            <input type="date" id="name" className="custom-input" placeholder="Select Time of Birth"/>
          </div>  

          <div className="flex-col flex gap-[8px]">
            <label className="text-[15px] text-gray-950 semibold">
            Place of Birth
            </label>
            <input type="text" id="name" className="custom-input" placeholder="Enter Place of Birth"/>
          </div>  
        </div>

        <h2 className='web-h5 text-gray-950 my-4'>Boy Details</h2>

        <div className='grid grid-cols-2 gap-[15px]'>
          <div className="flex-col flex gap-[8px]">
            <label className="text-[15px] text-gray-950 semibold">
                Name
            </label>
            <input type="text" id="name" className="custom-input" placeholder="Enter name"/>
          </div>  

          <div className="flex-col flex gap-[8px]">
            <label className="text-[15px] text-gray-950 semibold">
            Date of Birth
            </label>
            <input type="date" id="name" className="custom-input" placeholder="Select Date of Birth"/>
          </div>  

          <div className="flex-col flex gap-[8px]">
            <label className="text-[15px] text-gray-950 semibold">
            Time of Birth
            </label>
            <input type="time" id="name" className="custom-input" placeholder="Select Time of Birth"/>
          </div>  

          <div className="flex-col flex gap-[8px]">
            <label className="text-[15px] text-gray-950 semibold">
            Place of Birth
            </label>
            <input type="text" id="name" className="custom-input" placeholder="Enter Place of Birth"/>
          </div>  
        </div>
   
        <button className='custom-btn custom-btn-primary mt-4'>Match Now</button>


     </div>   
    </section>
  )
}

export default KundliMatching